import React from 'react'

import box_bg from '../../assets/box_bg.png'
import project_bg from '../../assets/ww.png'

const Terms = () => {
	return (
		<>
			<section
				className='privacy project_jumbo jumbo_section'
				style={{ background: `url(${box_bg})`, backgroundPosition: 'bottom' }}
			>
				<div className='container'>
					<div className='d-flex privacy_jumbo_text'>
						<div>
							<h1>Terms and Conditions</h1>
						</div>
					</div>
				</div>
			</section>

			<section
				className='privacy_div'
				style={{ background: `url(${project_bg})` }}
			>
				<div className='container'>
					<p>
						These End-User Terms of Use (the “Terms” or, “Agreement“) constitute
						an agreement made by and between you, a user of the Licensed System
						(as defined below) (“You“, or “Your“) and Sleeprate Inc.
						(“Sleeprate“), with respect to your use of the Licensed System.
					</p>
					<p>
						Please read these Terms carefully before accepting, and/or before
						subscribing to, downloading, installing or using the Licensed
						System. By clicking on the “I accept” (or similar consent) button or
						downloading, installing or using all or any portion of the Licensed
						System, you are accepting all of the Terms and conditions of this
						agreement.
					</p>
					<p>
						If you do not agree to all of these terms and conditions, do not
						click to accept or otherwise download, subscribe to, install or use
						the Licensed System.
					</p>

					<h5 className='terms_strong'>
						<strong>Term of Agreement.</strong>
					</h5>

					<p>
						This Agreement is effective as of or the Effective Date and for as
						long as you use the Application and the Services (the “Term“), or
						until terminated by Sleeprate. Upon the end of the Term, Your
						license to the Services provided herein shall be automatically
						terminated and You shall not have access to your account. Upon any
						violation by You of any of the provisions of this Agreement, which
						have not been remedied within the time specified in a written
						notice, after you have been given such written notice of the
						violation, which may be made via e-mail, rights to use the Licensed
						System shall automatically terminate.
					</p>
					<p>
						Effect of Termination. You may discontinue your Subscription through
						the appliable application store. However, this does not constitute
						an instruction to the Company to delete your account and data. In
						case you require that your account and data be deleted, you shall
						notify Sleeprate through the designated account deletion function in
						the Application. . Upon termination of the Subscription you may
						still view your account however you shall no longer be able to use
						the Services (unless you have requested the deletion of your account
						and data, as specified in the aforementioned) The provisions of
						paragraphs 1, 4, 5, 6 7, 8, 10, 11, 12 and 13 will survive any
						termination of this Agreement.
					</p>
					<p>
						Sleeprate may at any time terminate and discontinue the Services
						Subscription and the license of the Licensed System, under its sole
						discretion. In the event that Sleeprate does so, it shall not
						continue to charge the Subscription Fees for the remainder of the
						Subscription Term.
					</p>
				</div>
			</section>
		</>
	)
}

export default Terms
